import * as React from 'react';
import { useToastBody_unstable } from './useToastBody';
import { renderToastBody_unstable } from './renderToastBody';
import { useToastBodyStyles_unstable } from './useToastBodyStyles.styles';
/**
 * ToastBody component
 */ export const ToastBody = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useToastBody_unstable(props, ref);
    useToastBodyStyles_unstable(state);
    return renderToastBody_unstable(state);
});
ToastBody.displayName = 'ToastBody';
